import { useEffect, useState } from "react";
const useMountChildrenValidation = ({ isOpen, unmountChildrenOnClose })=>{
    const [wasOpened, setWasOpened] = useState(isOpen);
    useEffect(()=>{
        if (!wasOpened && isOpen) setWasOpened(true);
    }, [
        wasOpened,
        isOpen
    ]);
    return !!(unmountChildrenOnClose ? isOpen : isOpen || wasOpened);
};
const src_useMountChildrenValidation = useMountChildrenValidation;
export default src_useMountChildrenValidation;
